import querystring from 'querystring';
import { navigate } from 'gatsby';
import React from 'react';

import Card from '../components/Card';
import ContactCardFooter from '../components/ContactCardFooter';
import CreateAccountForm from '../components/CreateAccountForm';
import HeroImageSegment from '../components/HeroImageSegment';
import Interstitial from '../components/Interstitial';
import PageRoot from '../components/PageRoot';
import Query from '../components/Query';
import paths from '../paths';
import { AuthContext } from '../components/AuthWrapper';

const propTypes = {};

function CreateAccountPage({ location }) {
  const { token } = querystring.parse(location.search.slice(1)) || {};
  return (
    <Query
      variables={{ token }}
      query={
        /* GraphQL */ `
          query createAccountQuery($token: String!) {
            reservationInfoByToken(token: $token) {
              email
              isExpired
              isRegistered
              isDeviceOnly
            }
          }
        `
      }
    >
      {({
        reservationInfoByToken: {
          isRegistered,
          isExpired,
          isDeviceOnly,
          email,
        },
      }) => {
        if (isDeviceOnly) {
          return (
            <AuthContext.Consumer>
              {auth => {
                auth.setDeviceOnlyToken(token);
                navigate('/');
                return null;
              }}
            </AuthContext.Consumer>
          );
        }

        if (isRegistered) {
          navigate('/');
          return null;
        }
        if (isExpired) {
          navigate(paths.invitationExpired);
          return null;
        }
        return (
          <PageRoot theme="light" noFooter>
            <HeroImageSegment />
            <Interstitial>
              <Card.Body>
                <CreateAccountForm
                  token={token}
                  isDeviceOnly={isDeviceOnly}
                  email={email}
                />
              </Card.Body>
              <ContactCardFooter />
            </Interstitial>
          </PageRoot>
        );
      }}
    </Query>
  );
}

CreateAccountPage.propTypes = propTypes;

export default CreateAccountPage;
